import { createContext, type Dispatch, type SetStateAction, useContext } from 'react';

import type { ICarrierByParcel, INotiButtonStateByParcel } from '../../../interfaces';

export interface ITrackingDetailsContext {
  subAllApiState: boolean;
  carrierByParcel: ICarrierByParcel;
  setCarrierByParcel: Dispatch<SetStateAction<ICarrierByParcel>>;
  setSubAllApiState: Dispatch<SetStateAction<boolean>>;
  notiButtonStateByParcel: INotiButtonStateByParcel;
  setNotiButtonStateByParcel: Dispatch<SetStateAction<INotiButtonStateByParcel>>;
}

export const TrackingDetailsContext = createContext<ITrackingDetailsContext>({
  subAllApiState: false,
  carrierByParcel: {},
  setCarrierByParcel: () => null,
  setSubAllApiState: () => null,
  notiButtonStateByParcel: {},
  setNotiButtonStateByParcel: () => null,
});

interface ITrackingDetailsProviderProps {
  children: JSX.Element;
  value: ITrackingDetailsContext;
}

export const TrackingDetailsProvider = ({ children, value }: ITrackingDetailsProviderProps) => {
  return <TrackingDetailsContext.Provider value={value}>{children}</TrackingDetailsContext.Provider>;
};

export const useTrackingDetailsContext = () => useContext(TrackingDetailsContext);
